export enum FlashwareBedarf {
  THERE = 'modules.expert-tool.result.flash-requirement-opt.yes',
  NOTTHERE = 'modules.expert-tool.result.flash-requirement-opt.no',
  DOWNGRADE = 'modules.expert-tool.result.flash-requirement-opt.downgrade',
  CALCULATION_ERROR = 'modules.expert-tool.result.flash-requirement-opt.calculation-error',
}
